import downloadTrack from '../downloadTrack';

export default host => (musicId, isWav = false) => downloadTrack(host, musicId, 'music', false, true, isWav)
